import React, { Component, Fragment } from "react";
import { Link ,  NavLink , withRouter } from "react-router-dom";
import style from "../writer.css";
import AppContext from "../../../contexts/AppContext";


export class Header extends Component {
    render() {
        return (
            <Fragment>
                <header className="header-v2">
                    <div className="container-fluid">
                        <div className="d-flex align-items-center">
                            <div className="flex-body">
                                <a href="#" id="side-menu-button"><i className="fe fe-menu" aria-hidden="true"></i></a>
                                <a className="brand" href="#"><img src="/images/logo_w.png"  width="161" height="34"  alt="logo"/></a>
                            </div>
                            <div className="flex-body center">
                                <a className="brand" href="#"><img src="/images/logo_w.png" alt="logo"/></a>
                                <nav className="navbar">
                                    <ul className="nav navbar-nav">
                                        <li className="active">
                                            <a href="#">Education</a>
											<ul class="navbar-sub-nav d-flex align-items-center justify-content-center">
									            <li class="active"><a href="#">Pitching</a></li>
									        	<li><a href="#">Client Management</a></li>
									        	<li><a href="#">Writing</a></li>
									        	<li><a href="#">SEO</a></li>
								            </ul>
                                        </li>
                                        <li>
                                            <a href="#">Jobs</a>
                                        </li>
                                        <li>
                                            <a href="#">Community</a>
                                        </li>
                                        <li>
                                            <a href="#">Library</a>
                                        </li>
                                        <li>
                                            <a href="#">Tools</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                            <div className="flex-body right">
                                <a className="link" href="#">ABOUT</a>
                                <div className="btn-grp">
                                    <a className="link2" href="#"><i className="fe fe-bell" aria-hidden="true"></i></a>
                                    <a className="link2" href="#"><i className="fe fe-message-square" aria-hidden="true"></i></a>
                                    <a className="link3" href="#"><img src="/images/avatar.jpg" alt="profile-pic"/></a>
                                </div>
                            </div>
                        </div>
                        <div id="side-menu" className="side-menu">
                            <a href="#" className="btn btn-primary">Account</a>
                            <a href="#" className="btn btn-primary">Logout</a>
                            <nav className="navbar">
                                <ul className="nav navbar-nav">
                                    <li className="active">
                                        <a href="#">Education</a>
                                        <ul className="navbar-sub-nav d-flex align-items-center justify-content-center">
                                            <li><a href="#">Pitching</a></li>
                                            <li className="active"><a href="#">Client Management</a></li>
                                            <li><a href="#">Writing</a></li>
                                            <li><a href="#">SEO</a></li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="#">Jobs</a>
                                        <ul className="navbar-sub-nav d-flex align-items-center justify-content-center">
                                            <li><a href="#">Search</a></li>
                                            <li><a href="#">Favorited</a></li>
                                            <li><a href="#">Applications</a></li>
                                            <li><a href="#">My Jobs</a></li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="#">Community</a>
                                        <ul className="navbar-sub-nav d-flex align-items-center justify-content-center">
                                            <li><a href="#">Groups</a></li>
                                            <li><a href="#">Question</a></li>
                                            <li><a href="#">Achievements</a></li>
                                            <li><a href="#">Writers</a></li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="#">Library</a>
                                        <ul className="navbar-sub-nav d-flex align-items-center justify-content-center">
                                            <li><a href="#">Articles</a></li>
                                            <li><a href="#">Videos</a></li>
                                            <li><a href="#">Podcasts</a></li>
                                            <li><a href="#">Case Studies</a></li>
                                            <li><a href="#">Guides</a></li>
                                            <li><a href="#">Resources</a></li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="#">Tools</a>
                                        <ul className="navbar-sub-nav d-flex align-items-center justify-content-center">
                                            <li><a href="#">Portfolios</a></li>
                                            <li><a href="#">Submissions</a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </header>

            </Fragment>
        );
    }
}
Header.contextType = AppContext;

export default withRouter(({ location, ...props }) => {
    return <Header {...props}   />;
 });



// WEBPACK FOOTER //
// ./src/components/writer/education/Header.js